export const FormatAmount = (amount) => {
    if (typeof amount === "string") {
      amount = parseFloat(amount);
    }
    if (typeof amount === "number" && !isNaN(amount)) {
      return amount.toLocaleString();
    } else {
      console.error("Invalid amount:", amount);
      return amount;
    }
  };